import ParcelProvider from './ParcelProvider';
import ThemeProvider from './ThemeProvider';

export default function Provider({ children }) {
  return (
    <ThemeProvider>
      <ParcelProvider>{children}</ParcelProvider>
    </ThemeProvider>
  );
}
